import { useQuery, useQueryClient } from "@tanstack/react-query";
import type { AxiosError } from "axios";

import { axios } from "~/core/axios";
import { REACT_QUERY_KEY } from "~/core/constants/common";
import type {
  BackendApiErrorResponse,
  BackendApiResponse,
} from "~/core/types/backend-api-response.type";

import type { IntegrationResponse } from "~/components/Integration/types/api-response";

export const useFetchAllIntegrations = () => {
  return useQuery<IntegrationResponse[], AxiosError<BackendApiErrorResponse>>({
    queryKey: [REACT_QUERY_KEY.INTEGRATION_ALL],
    queryFn: async () => {
      try {
        const { data } =
          await axios.get<BackendApiResponse<IntegrationResponse[]>>(
            "/integration/all",
          );

        return data.data ?? [];
      } catch (error) {
        const err = error as AxiosError<BackendApiErrorResponse>;
        console.error(
          err.response?.data?.message || "Failed to fetch integrations",
        );
        throw error;
      }
    },
    retry: false,
    refetchOnMount: true,
    refetchOnWindowFocus: "always",
  });
};

export const useInvalidateAllIntegrations = () => {
  const queryClient = useQueryClient();

  return () => {
    queryClient.invalidateQueries({
      queryKey: [REACT_QUERY_KEY.INTEGRATION_ALL],
    });
  };
};
